import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.2597 36.356L1.16038 58.4104C0.678027 59.0712 1.14997 60 1.96807 60H78.1243C78.9245 60 79.4006 59.107 78.9546 58.4427L53.9259 21.1568C53.5445 20.5887 52.7181 20.5628 52.3019 21.1059L32.4723 46.9817C32.1189 47.4429 31.4482 47.5068 31.0141 47.1207L18.7319 36.1983C18.2908 35.8061 17.6077 35.8792 17.2597 36.356Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }